<template>
  <div class="road-signpost flex flex-col items-center">
    <!-- Signpost SVG -->
    <svg width="140" height="56" viewBox="0 0 140 56" fill="none" class="drop-shadow-md">
      <!-- Post -->
      <rect x="66" y="28" width="8" height="28" rx="2" fill="#92400e" />
      <!-- Sign board -->
      <rect x="10" y="2" width="120" height="28" rx="4" fill="#16a34a" />
      <rect x="12" y="4" width="116" height="24" rx="3" fill="#22c55e" />
      <!-- Text -->
      <text x="70" y="20" text-anchor="middle" dominant-baseline="middle"
        fill="white" font-size="11" font-weight="bold" class="font-sans">
        {{ truncatedTitle }}
      </text>
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: { type: String, required: true }
});

const truncatedTitle = computed(() => {
  return props.title.length > 20 ? props.title.slice(0, 18) + '...' : props.title;
});
</script>
